module.exports = __webpack_public_path__ + "media/metronic/_theme/media/products/product1-1a86b597e01b07b850f4858d7a78fba4.jpg";